interface FormGroupItemDescriptor
{
	input: BasicInputField|InputGroup;
	label?: InputLabel;
	size?: GridSizing|any;
	help?: string;
}

class FormGroup
{
	private element: JQuery;
	private container: JQuery;
	private ColCount: number;
	private ItemCount: number;
	private Width: number[];
	private Horizontal: boolean;
	private Inline: boolean;
	private m_Input: BasicInputField[];

	constructor( width: number[], horizontal: boolean, inline: boolean )
	{
		this.element = $( document.createElement( 'div' ) );
		this.ItemCount = 0;
		this.ColCount = 0;
		this.Width = [];
		this.Horizontal = horizontal;
		this.Inline = inline;
		this.m_Input	= [];
		this.container = $( document.createElement( 'div' ) );

		this.element.addClass( 'form-group' );

		if ( width && !inline )
		{
			for ( let i = 0; i < clamp( width.length, 0, 4 ); ++i )
			{
				this.ColCount += width[ i ];
				this.Width.push( width[ i ] );
			}

			this.container.addClass( 'col-xs-12' );
			this.container.css('clear', 'both');

			this.element.append( this.container );
		}
	}

	public Inputs(): BasicInputField[]
	{
		return this.m_Input;
	}

	public addItem( descriptor: FormGroupItemDescriptor ) : JQuery
	{
		let tempDiv = this.element;

		if ( !this.Inline )
		{
			tempDiv = $( document.createElement( 'div' ) );

			if ( this.ItemCount < this.Width.length )
			{
				tempDiv.addClass( 'form-group-item' );
				tempDiv.css( 'width', ( this.Width.length > 1 ? clamp( (100 * this.Width[this.ItemCount] / this.ColCount), 15, 85 ) : 100 ) + '%' );
			}
			else
			{
				tempDiv.addClass( 'col-xs-12' );
			}

			this.element.append( tempDiv );
		}

		if ( descriptor.label )
		{
			tempDiv.append( this.appendElement( $( descriptor.label.getElement() ), this.Horizontal, descriptor, 4 ) );
		}
		else if ( !this.Inline && !this.Horizontal )
		{
			const lbl = document.createElement( 'label' );
			lbl.innerHTML = '&nbsp;';
			tempDiv.append( lbl );
		}

		let inputDiv = $( descriptor.input.getElement() );
		if ( this.Horizontal )
		{
			inputDiv = $( document.createElement( 'div' ) );
			inputDiv.append( descriptor.input.getElement() );
		}
		tempDiv.append( this.appendElement( inputDiv, this.Horizontal, descriptor, descriptor.label ? 8 : 12 ) );

		if ( descriptor.help )
		{
			const tempHelp = $( document.createElement( 'p' ) );

			tempHelp.addClass( 'help-block' );
			tempHelp.html( descriptor.help );

			tempDiv.append( tempHelp );
		}

		if ( this.ItemCount < this.Width.length )
		{
			this.container.append( tempDiv );
		}

		++this.ItemCount;
		if ( descriptor.input instanceof BasicInputField )
		{
			this.m_Input.push( descriptor.input );
		}

		return $( descriptor.input.getElement() );
	}

	public getElement() : HTMLElement
	{
		return this.element[ 0 ];
	}

	private appendElement( element: JQuery, size: boolean, descriptor: FormGroupItemDescriptor, default_length: number ) : JQuery
	{
		if ( size )
		{
			if ( descriptor.size && !$.isEmptyObject( descriptor.size ) )
			{
				let k: any;
				for ( k in descriptor.size )
				{
					element.addClass( 'col-' + k + '-' + clamp( 12 - descriptor.size[ k ], 2, 10 ) );
				}
			}
			else if ( !this.Inline )
			{
				element.addClass( 'col-xs-12 col-sm-12 col-md-' + default_length );
			}
		}

		return element;
	}
}
